var map = {
	"./icon-wg.png": 13216,
	"./icon1.png": 46758,
	"./icon10.png": 3380,
	"./icon11.png": 24509,
	"./icon12.png": 83270,
	"./icon2.png": 44317,
	"./icon3.png": 11284,
	"./icon4.png": 61195,
	"./icon5.png": 40066,
	"./icon6.png": 96153,
	"./icon7.png": 89904,
	"./icon8.png": 9815,
	"./icon9.png": 64238
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16510;